import type { FC } from 'react';
import { alpha, useTheme } from '@mui/material/styles';
import { Toaster as HotToaster } from 'react-hot-toast';

import { fpAuthColors } from '../theme/fp-auth-colors';

export const FPToaster: FC = () => {
  const theme = useTheme();

  return (
    <HotToaster
      position="bottom-center"
      toastOptions={{
        style: {
          backdropFilter: 'blur(6px)',
          background: alpha(fpAuthColors.fpDarkBlue, 0.8),
          color: theme.palette.common.white,
          boxShadow: theme.shadows[16],
        },
      }}
    />
  );
};
